import React from "react";
import { Pagination, A11y, Autoplay } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

import hero1 from "../../images/hero/image-5.jpg";
import hero2 from "../../images/hero/image-6.jpg";
import shape from "../../images/hero/text-shape-2.svg";

const Hero4: React.FC = () => {
  return (
    <section className="wpo-hero-slider-s4">
      <div className="swiper-container">
        <div className="swiper-wrapper">
          <Swiper
            modules={[Pagination, A11y, Autoplay]}
            spaceBetween={0}
            slidesPerView={1}
            loop={true}
            pagination={{ clickable: true }}
            speed={1800}
            parallax={true}
            autoplay={{
              delay: 4000,
              disableOnInteraction: false,
            }}
          >
            <SwiperSlide>
              <div
                className="slide-inner slide-bg-image"
                style={{ backgroundImage: `url(${hero1})` }}
              >
                <div className="container-fluid">
                  <div className="slide-content">
                    <div
                      className="slide-title wow fadeInUp"
                      data-wow-delay="0.1s"
                    >
                      <h2>Seamless Planning, Timeless Memories.</h2>
                      <img className="text-image" src={shape} alt="shape" />
                    </div>
                    <div
                      className="slide-text wow fadeInUp"
                      data-wow-delay="0.2s"
                    >
                      <p>
                        We are getting Married. Let's create a remarkable
                        journey where our dreams become realities.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </SwiperSlide>

            <SwiperSlide>
              <div
                className="slide-inner slide-bg-image"
                style={{ backgroundImage: `url(${hero2})` }}
              >
                <div className="container-fluid">
                  <div className="slide-content">
                    <div
                      className="slide-title wow fadeInUp"
                      data-wow-delay="0.1s"
                    >
                      <h2>Seamless Planning, Timeless Memories.</h2>
                      <img className="text-image" src={shape} alt="shape" />
                    </div>
                    <div
                      className="slide-text wow fadeInUp"
                      data-wow-delay="0.2s"
                    >
                      <p>
                        We are getting Married. Let's create a remarkable
                        journey where our dreams become realities.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          </Swiper>
        </div>
        <div className="swiper-pagination"></div>
      </div>
    </section>
  );
};

export default Hero4;
